exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-assignment-grading.js-WebpackMultiOutput";